import React from 'react';
import { Link } from 'react-router-dom';

const Dance = () => {
  return (
    <div className="min-h-screen px-4 py-12 bg-gradient-to-br from-pink-100 via-yellow-50 to-red-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 transition duration-300">
      <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden flex flex-col md:flex-row items-center">

        {/* Image Section */}
        <div className="md:w-1/2 flex justify-center items-center p-4">
          <img
            src="https://plus.unsplash.com/premium_photo-1682089706055-d5ef14dc14e4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8ZGFuY2V8ZW58MHx8MHx8fDA%3D"
            alt="Dance Session"
            className="w-full max-w-sm h-auto rounded-lg object-cover shadow-md"
          />
        </div>
        <div className="md:w-1/2 p-4 md:p-6 flex flex-col justify-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-white mb-4">
            💃 Dance Teacher
          </h1>
          <p className="text-base text-gray-700 dark:text-gray-300 mb-4 leading-relaxed">
            Let your child express through movement! Our passionate dance teachers bring energy,
            grace, and fun to every session.
          </p>
          <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 shadow-inner mb-4">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">🩰 Dance Forms Offered:</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-200 text-sm">
              <li>🎵 Classical (Kathak, Bharatanatyam)</li>
              <li>💃 Western</li>
              <li>🎬 Bollywood & Folk</li>
              <li>🕺 Freestyle for kids</li>
            </ul>
          </div>
          <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 shadow-inner mb-6">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">✨ Why Choose Us:</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-200 text-sm">
              <li>🎭 Certified and experienced dance instructors</li>
              <li>🏠 Home training and online sessions available</li>
              <li>🏫 Dance training at your school or center</li>
              <li>👯 Male & Female instructors based on preference</li>
              <li>🎉 Fun events & performance showcases</li>
              <li>📆 Weekend & weekday batches with flexible timing</li>
              <li>💬 Personal mentorship for kids</li>
            </ul>
          </div>
          <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-4 mt-6">
            <Link to="/contact">
              <button className="bg-pink-600 hover:bg-pink-700 text-white text-sm font-medium px-6 py-3 rounded-md shadow transition duration-300 w-64 sm:w-auto">
                Book a Free Demo Class
              </button>
            </Link>
            <a
              href="https://wa.me/919999999999"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white text-sm font-medium px-6 py-3 rounded-md shadow transition duration-300 w-64 sm:w-auto text-center"
            >
              📲 Connect on WhatsApp
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Dance;
